import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { refreshProviderAccount } from "../../actions";
var defaultState = {
  failures: {}
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case refreshProviderAccount.FAIL_TYPE:
      {
        var _action$meta = action.meta,
            isAutoRefresh = _action$meta.isAutoRefresh,
            providerAccountStateId = _action$meta.providerAccountStateId;

        if (isAutoRefresh) {
          return _objectSpread(_objectSpread({}, state), {}, {
            failures: _objectSpread(_objectSpread({}, state.failures), {}, _defineProperty({}, providerAccountStateId, true))
          });
        }

        return state;
      }

    default:
      return state;
  }
});